import { supabase } from "../supabase/SupabaseClient";
import { traerTodas } from "./paginar";

/* Las visitas del portón: quién entró caminando y a quién venía a ver.
 *
 * ── ESTA PANTALLA ES DE MIRAR ─────────────────────────────────────────────
 *
 * Se cargan por WhatsApp, desde el portón, con la persona parada adelante:
 * «Ingreso: Carlos, empresa Michelin, entra caminando, viene a ver a Nicolás
 * Cantarini». Un formulario acá sería un segundo lugar para lo mismo, y el
 * día que se cargue en el que no es esa visita no aparece en ningún lado. Es
 * la lección de los dos talleres, y la misma decisión que las dos pantallas
 * del puerto.
 *
 * ── Y LO QUE DE VERDAD RESTRINGE ES LA RLS ────────────────────────────────
 *
 * `visitas` tiene política de lectura para `authenticated` y **ninguna de
 * escritura**: sólo escribe FlotaBot, que usa la service key. Un `.insert()`
 * desde el navegador no escribiría nada y PostgREST contestaría 200 con cero
 * filas — el 200-que-no-es-un-éxito. Por eso acá no hay ninguna función que
 * escriba: no es que falte, es que no puede haberla.
 */

/* Las visitas de un rango, de la más nueva a la más vieja.
 *
 * SE PIDE UN RANGO Y NO «LAS ÚLTIMAS N». La pregunta de esta pantalla es
 * «¿quién entró hoy?», y un tope de filas contestaría distinto según cuánta
 * gente vino — un día de mucho movimiento se comería la mañana.
 */
export async function visitas(desde, hasta) {
  return traerTodas(() =>
    supabase
      .from("visitas")
      .select(
        "id, ingreso_en, nombre, empresa, como, a_quien, a_quien_nombre, " +
          "a_quien_numero, aviso_ok, aviso_motivo, quien, anulado_en",
        { count: "exact" },
      )
      .gte("ingreso_en", desde)
      .lt("ingreso_en", hasta)
      .order("ingreso_en", { ascending: false })
      // Dos ingresos en el mismo instante empatan; el id desempata.
      .order("id", { ascending: false }),
  );
}
